import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE, ViewType } from '../../../grid/gridView/types';
import {
  getColumnDetails,
  DISPLAYED_COLUMNS,
  DISPLAYED_FILTERS,
  MobileSecurityCompanyGridWebComponentSchema,
  MobileSecurityCompanyRecord,
} from '../types';
import { sanitizeObject } from '../../../utils/sanitization.utils';

export class MobileSecurityCompanyGridDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<MobileSecurityCompanyGridWebComponentSchema> {
    const view = {
      id: 'mobile-security-company-grid',
      name: 'Default mobile security company grid',
      type: ViewType.DEFAULT,
      filters: DISPLAYED_FILTERS,
      displayedColumns: DISPLAYED_COLUMNS,
      pageSize: DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      compactView: false,
    };

    return {
      view,
      columns: getColumnDetails(this.dependencies.translateFn),
    };
  }

  public async createAccount(companyId: string): Promise<{ success: boolean }> {
    const res = await this.dependencies.api.clients.MobileSecurity.createAccount(companyId).toPromise();
    return sanitizeObject(res);
  }

  public async getCompanies(): Promise<[MobileSecurityCompanyRecord]> {
    const res = await this.dependencies.api.clients.Company.getCompaniesWithMobileSecurity().toPromise();
    return sanitizeObject(res['data']);
  }
}
